import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { mainnet, polygon, arbitrum } from 'wagmi/chains'
import { createStorage } from 'wagmi'

// Get projectId from https://cloud.walletconnect.com
export const projectId = '4b76d58d8dc4a1a9e04964fa16458eae'

if (!projectId) throw new Error('Project ID is not defined')

const metadata = {
  name: 'PIOFarming Game',
  description: 'Farm, earn and own on the Pio blockchain',
  url: 'https://demo-farm-game.preview.emergentagent.com',
  icons: ['https://demo-farm-game.preview.emergentagent.com/logo.png']
}

// Create wagmiConfig
const chains = [mainnet, polygon, arbitrum]

// Create a no-op storage to prevent persistence
const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
}

export const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableWalletConnect: true,
  enableInjected: true,
  enableEIP6963: true,
  enableCoinbase: true,
  // Completely disable storage to prevent auto-reconnect
  ssr: false,
  storage: createStorage({ storage: noopStorage }),
})
